import React from 'react';
import {
  Box,
  Button,
  Link,
  Typography,
  Stack,
} from '@mui/material';
import { ReactComponent as ZicassoSVG } from '../../../assets/svg/zicasso.svg';

const TripRequestConfirmationView = ({
  handleViewClick,
  isViewButtonDisabled,
  newUser,
}: {
  handleViewClick: () => void;
  isViewButtonDisabled: boolean;
  newUser: boolean;
}): React.ReactElement => (
  <Box
    sx={{
      width: '100%',
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    <Stack
      spacing={5}
      sx={{
        width: { mobile: '342px', desktop: '333px' },
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <Stack flexDirection="column" spacing={2} alignItems="center">
        <ZicassoSVG aria-label="Zicasso" />

        {newUser ? (
          <>
            <Typography variant="h2" color="text.primary" sx={{ textAlign: 'center' }}>
              Thank you for submitting your trip request!
            </Typography>
            <Typography color="text.secondary" style={{ marginTop: '10px', textAlign: 'center' }}>
              Our team is reviewing your trip request to match you with top travel specialists. You should hear from them shortly.
            </Typography>
          </>
        ) : (
          <>
            <Typography variant="h2" color="text.primary" sx={{ textAlign: 'center' }}>
              Thank you for submitting your trip request!
            </Typography>
            <Typography color="text.secondary" style={{ marginTop: '10px', textAlign: 'center' }}>
              We are carefully reviewing the details of your trip request, and we will reach out to you in 1-2 business days (or sooner!) to discuss the next steps in your travel planning.
            </Typography>
          </>
        )}
      </Stack>

      <Box
        display="flex"
        flexDirection="column"
        width="100%"
      >
        <Button
          disabled={isViewButtonDisabled}
          onClick={handleViewClick}
          variant="contained"
          fullWidth
        >
          {newUser ? 'Continue' : 'View my Trip Request'}
        </Button>
        <Typography sx={{ mt: 3, textAlign: 'center' }}>
          Need help?
          {' '}
          <Link component="a" href="/support">Contact Support Center</Link>
        </Typography>
      </Box>
    </Stack>
  </Box>
);

export default TripRequestConfirmationView;
